import React, {useState} from 'react';
import {validateWarrantieData} from '../../utils/validation';
import { initialWarrantieFormData } from '../../utils/formData';


function WarrantieForm() {
  const [errors, setErrors] = useState({});

    // initialisation des  champs du formulaire
    const [formData, setFormData] = useState(initialWarrantieFormData);

  // Fonction pour gérer les changements dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Fonction pour valider les champs
  const validateFields = () => {
    let newErrors = {};

        newErrors = validateWarrantieData(formData);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //fonction de soumission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateFields()) {
      console.log('Formulaire soumis avec succès:', formData);
    }
  };

  return (
    <form onSubmit={handleSubmit} className='inscription-form'>
          <div className="form-step">
            <h2 className='inscription-title'>Ajout d'une garantie</h2>
            <div className="form-row">
                <div className="form-group">
                    <label>Nom  :</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder='Entrez le nom garantoe ....' />
                    {errors.name && <p className="error">{errors.name}</p>}
                </div>
                <div className="form-group">
                    <label>Couverture</label>
                    <input type="text" name="coverage" value={formData.coverag} onChange={handleChange} placeholder='Entrez le taux de couverture..' />
                    {errors.coverage && <p className="error">{errors.coverage}</p>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Service</label>
                    <select name="serviceId" value={formData.serviceId} onChange={handleChange}>
                        <option value="1">Consultation géneraliste </option>
                        <option value="2">Hospitalisation</option>
                    </select>
                    {errors.serviceId && <p className="error">{errors.serviceId}</p>}
                </div>
                <div className="form-group">
                    <label>Limite</label>
                    <input type="text" name="limit" value={formData.limit} onChange={handleChange} placeholder='la limte Ex 1000' />
                    {errors.limit && <span className="error">{errors.limit}</span>}
                </div>
                <div className="form-group">
                    <label>Type de limite</label>
                    <input type="text" name="limitType" value={formData.limitType} onChange={handleChange} placeholder='la limte Ex 1000' />
                    {errors.limitType && <span className="error">{errors.limitType}</span>}
                </div>
            </div>
          </div>

          <button type="submit" className="submit-button">
             Enregistrer
          </button>
        
      </form>
  )
}

export default WarrantieForm